import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { StudentDocumentVaultResponse, DocumentTypeEnum, DocumentCategoryEnum, DocumentStatusEnum } from '../../../models/student-document-vault/student-document-vault';

@Component({
  selector: 'app-document-vault-card',
  standalone: true,
  imports: [CommonModule, ButtonModule, TooltipModule],
  templateUrl: './document-vault-card.component.html',
  styleUrls: ['./document-vault-card.component.scss']
})
export class DocumentVaultCardComponent {
  @Input() doc!: StudentDocumentVaultResponse;
  @Input() showActions: boolean = true;
  
  @Output() onEdit = new EventEmitter<StudentDocumentVaultResponse>();
  @Output() onDelete = new EventEmitter<string>();

  get isMissing(): boolean {
    return this.doc.status === DocumentStatusEnum.Missing;
  }

  get isFulfilled(): boolean {
    return this.doc.status === DocumentStatusEnum.Uploaded && this.doc.isRequested;
  }

  DocumentStatusEnum = DocumentStatusEnum;

  DocumentTypeEnum = DocumentTypeEnum;
  DocumentCategoryEnum = DocumentCategoryEnum;

  editDocument() {
    this.onEdit.emit(this.doc);
  }

  deleteDocument() {
    this.onDelete.emit(this.doc.id);
  }

  openOrDownload() {
    if (!this.doc.path) return;
    window.open(this.doc.path, '_blank');
  }
}
